import { ref, type Ref } from '#imports';

export function useAppSpinner() {
  const isSpinnerVisible = ref(false);

  const showSpinner = () => {
    isSpinnerVisible.value = true;
  };

  const hideSpinner = () => {
    isSpinnerVisible.value = false;
  };

  return {
    isSpinnerVisible: isSpinnerVisible as Ref<boolean>,
    showSpinner,
    hideSpinner,
  };
}
